import React from 'react'
import { FormBody } from './FormBody'
import { FormInitialization } from './Initialization/FormInitialization'
import { FormEventPoller } from './Poller/FormEventPoller'

export const Forms: React.FC = () => {
  return (
    <>
      <FormEventPoller />
      <FormInitialization />
      <FormBody />
    </>
  )
}
